/**
 * ChevronRightIcon/index.js
 * desc: navigation back arrow
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ChevronRightIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="chevron-right icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.chevronRight.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg"><path d="M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6-6-6z"/></svg>
    </IconButton>
);


export default ChevronRightIcon;
